import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "columns is-multiline" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "label is-small" }, "Email utilizador", -1)
const _hoisted_6 = { class: "control has-icons-left has-icons-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)
const _hoisted_10 = { class: "mt-4 columns" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-6 has-text-weight-semibold" }, "Ativar módulo", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "all_active" }, "Renovar ativos", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "all_inactive" }, "Renovar inativos", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "all" }, "Renovar todos", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "──────────", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-6 has-text-weight-semibold" }, "Periodo", -1)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">1 Dia</option><option value=\"3\">3 Dias</option><option value=\"7\">1 Semana</option><option value=\"15\">15 Dias</option><option value=\"31\">1 Mês</option><option value=\"61\">2 Meses</option><option value=\"90\">1 Trimestre</option><option value=\"180\">1 Semestre</option><option value=\"365\">1 Ano</option><option value=\"720\">2 Anos</option><option value=\"1095\">3 Anos</option>", 11)
const _hoisted_29 = [
  _hoisted_18
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-6 has-text-weight-semibold" }, "Periodo", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "modulo" }, "a partir da validade do módulo", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "agora" }, "a partir de hoje", -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "mt-4" }
const _hoisted_35 = { class: "column" }
const _hoisted_36 = { class: "table is-fullwidth is-hoverable is-striped" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "is-size-7" }, "Módulo"),
    /*#__PURE__*/_createElementVNode("th", { class: "is-size-7 has-text-centered" }, "Validade")
  ])
], -1)
const _hoisted_38 = { class: "is-size-7" }
const _hoisted_39 = { class: "is-size-7 has-text-centered" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_41 = { class: "mt-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-grey-light has-text-weight-semibold mt-4",
  "data-v-745807e0": ""
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {"height":"22px"},
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Alterar dados de licenciamento ")
], -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Nome ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Morada ")
const _hoisted_45 = { class: "columns" }
const _hoisted_46 = { class: "column" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Código Postal ")
const _hoisted_48 = { class: "column" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Cidade ")
const _hoisted_50 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button is-light is-primary"
}, [
  /*#__PURE__*/_createTextVNode("Alterar dados da "),
  /*#__PURE__*/_createElementVNode("strong", null, "licença")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass([{'is-danger':!_ctx.isEmailValid}, "input is-small"]),
                type: "email",
                placeholder: "ex. email@utilizador.pt",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userEmail) = $event))
              }, null, 2), [
                [_vModelText, _ctx.userEmail]
              ]),
              _hoisted_7
            ]),
            (!_ctx.isEmailValid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Email utilizador inexistente!"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeCompanyUserByEmail && _ctx.changeCompanyUserByEmail(...args))),
            class: "button is-light is-primary is-fullwidth is-small"
          }, "Alterar ")
        ]),
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _hoisted_12,
          _withDirectives(_createElementVNode("select", {
            class: "select is-fullwidth",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedModule) = $event))
          }, [
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (module) => {
              return (_openBlock(), _createElementBlock("option", { key: module }, _toDisplayString(module), 1))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedModule]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_17,
          _withDirectives(_createElementVNode("select", {
            class: "select is-fullwidth",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedPeriod) = $event))
          }, _hoisted_29, 512), [
            [_vModelSelect, _ctx.selectedPeriod]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_30,
          _withDirectives(_createElementVNode("select", {
            class: "select is-fullwidth",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activationStartDate) = $event))
          }, _hoisted_33, 512), [
            [_vModelSelect, _ctx.activationStartDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.requestModuleActivation && _ctx.requestModuleActivation(...args))),
            class: "button is-primary is-light is-fullwidth"
          }, "Ativar")
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("table", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.info.modulos, (module) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: module.modulo
              }, [
                _createElementVNode("td", _hoisted_38, _toDisplayString(module.modulo), 1),
                _createElementVNode("td", _hoisted_39, _toDisplayString(module.validade), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_40,
    _createElementVNode("div", _hoisted_41, [
      _hoisted_42,
      _createElementVNode("form", {
        class: "is-flex is-flex-direction-column mt-4",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeCompanyLicenseData && _ctx.changeCompanyLicenseData(...args)), ["prevent"]))
      }, [
        _createElementVNode("label", null, [
          _hoisted_43,
          _withDirectives(_createElementVNode("input", {
            class: "input is-small",
            type: "text",
            placeholder: "Nome da empresa",
            name: "name",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.licenseData.name) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.licenseData.name]
          ])
        ]),
        _createElementVNode("label", null, [
          _hoisted_44,
          _withDirectives(_createElementVNode("input", {
            class: "input is-small",
            type: "text",
            placeholder: "Endereço da empresa",
            name: "address",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.licenseData.address) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.licenseData.address]
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("label", null, [
              _hoisted_47,
              _withDirectives(_createElementVNode("input", {
                class: "input is-small",
                type: "text",
                placeholder: "0000-000",
                name: "zipcode",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.licenseData.zipcode) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.licenseData.zipcode]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("label", null, [
              _hoisted_49,
              _withDirectives(_createElementVNode("input", {
                class: "input is-small",
                type: "text",
                placeholder: "",
                name: "city",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.licenseData.city) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.licenseData.city]
              ])
            ])
          ])
        ]),
        _hoisted_50
      ], 32)
    ])
  ]))
}